import { useEffect } from 'react';
import { TextField } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/hooks';
import { updateTicketCustomerInfo } from '../../../../state';
import { useGraphProfile } from '../../../../hooks';

const CustomerLocationEdit: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentTicket } = useAppSelector(state => state.ticket);
  const { graphData } = useGraphProfile();

  useEffect(() => {
    if (graphData?.officeLocation && !currentTicket?.customerInfo.customerLocation) {
      dispatch(updateTicketCustomerInfo({ customerLocation: graphData.officeLocation }));
    }
  }, [dispatch, graphData, currentTicket?.customerInfo.customerLocation]);

  return (
    <TextField
      label="Location"
      size="small"
      fullWidth
      value={currentTicket?.customerInfo.customerLocation || ''}
      placeholder="Auto-populated from user profile"
      disabled={true}
    />
  );
};

export default CustomerLocationEdit;
